import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Svg from "../../../common/svgIcon";

import "./styles.scss";

export class BookmakersListHeader extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isBestOddsDropdownActive: false,
			bookmakersList: [],
			isMobile: false,
		};
	}

	toggleBookmakersDropdown = () => {
		this.setState((prevState) => ({
			isBestOddsDropdownActive: !prevState.isBestOddsDropdownActive,
		}));
	};

	unselectTierTwoBookmakerOnMobile = () => {
		const isMobile = window.innerWidth < 720;
		const { onSelect, selectedBookmaker, bookmakers } = this.props;

		const isAvailableOnPhone =
			bookmakers.length > 0 &&
			bookmakers.find((bookmaker) => bookmaker.feed === selectedBookmaker).availableOnPhone;
		if (isMobile && !isAvailableOnPhone) {
			onSelect("#BESTODDS", false);
		}

		this.setState({
			isMobile,
		});
	};

	getCookie = (name) => {
       const value = `; ${document.cookie}`;
       const parts = value.split(`; ${name}=`);
       if (parts.length === 2) {
		   return parts.pop().split(';').shift();
       }

	   return null
   }

    removeCookie = (name, value, path, domain) => {
       document.cookie = `${name}=${value};expires=-1;path=${path};domain=${domain}`;
	}

	componentDidMount() {
		const { onSelect } = this.props;
		// Note:
		// With the removal of Sporting Bet we need to fallback
		// the selected bookmaker to BestOdds
		if (this.props.selectedBookmaker === "SPORTING INDEX") {
		   this.props.onSelect("#BESTODDS", false);
		} else {
			const defaultChooseBookie = this.getCookie('defaultChooseBookie');
			if (defaultChooseBookie) {
				const domain = `.${window.location.host.split('.').slice(1).join('.')}`;
				this.removeCookie('defaultChooseBookie', defaultChooseBookie, '/', domain)
				onSelect(defaultChooseBookie, false);
			}
		}
		window.addEventListener("resize", this.unselectTierTwoBookmakerOnMobile.bind(this));
		// eslint-disable-next-line react/no-did-mount-set-state
		this.unselectTierTwoBookmakerOnMobile();
	}

	componentWillUnmount() {
		window.removeEventListener("resize", this.unselectTierTwoBookmakerOnMobile.bind(this));
	}

	render() {
		const { bookmakers, loggedInBookmakersList, onSelect, selectedBookmaker } = this.props;

		const isLoggedToAnyBookmaker = loggedInBookmakersList.length > 0;
		const rawBalanceData = loggedInBookmakersList.reduce(
			(acc, curr) => {
				if (curr.userInfo.currency === "GBP") {
					return {
						...acc,
						totalBalance: {
							...acc.totalBalance,
							GBP: acc.totalBalance.GBP + curr.userInfo.balance,
						},
						totalFreeBets: {
							...acc.totalFreeBets,
							GBP: acc.totalFreeBets.GBP + curr.userInfo.freeBetBalance,
						},
					};
				} else if (curr.userInfo.currency === "EUR") {
					return {
						...acc,
						totalBalance: {
							...acc.totalBalance,
							EUR: acc.totalBalance.EUR + curr.userInfo.balance,
						},
						totalFreeBets: {
							...acc.totalFreeBets,
							EUR: acc.totalFreeBets.EUR + curr.userInfo.freeBetBalance,
						},
					};
				}

				return {
					...acc,
					totalBalance: {
						...acc.totalBalance,
						USD: acc.totalBalance.USD + curr.userInfo.balance,
					},
					totalFreeBets: {
						...acc.totalFreeBets,
						USD: acc.totalFreeBets.USD + curr.userInfo.freeBetBalance,
					},
				};
			},
			{
				totalBalance: {
					GBP: 0,
					USD: 0,
					EUR: 0,
				},
				totalFreeBets: {
					GBP: 0,
					USD: 0,
					EUR: 0,
				},
			}
		);

		const totalBalance = Object.values(rawBalanceData.totalBalance)
			.map((balance, index) =>
				new Intl.NumberFormat("en-GB", {
					style: "currency",
					currency: index === 0 ? "GBP" : index === 1 ? "USD" : "EUR",
					minimumFractionDigits: 2,
				}).format(balance)
			)
			.filter((item) => {
				const transformed = item.replace("US", ""); // it adds US in front and we don't want it

				if (transformed.substring(1) === "0.00") {
					return false;
				}

				return true;
			})
			.join(" + ");

		const totalFreeBets = Object.values(rawBalanceData.totalFreeBets)
			.map((freeBet, index) =>
				new Intl.NumberFormat("en-GB", {
					style: "currency",
					currency: index === 0 ? "GBP" : index === 1 ? "USD" : "EUR",
					minimumFractionDigits: 2,
				}).format(freeBet)
			)
			.filter((item) => {
				const transformed = item.replace("US", ""); // it adds US in front and we don't want it

				if (transformed.substring(1) === "0.00") {
					return false;
				}

				return true;
			})
			.join(" + ");

		const bestOdds = bookmakers.find((bookmaker) => bookmaker.name === "BestOdds");
		const filteredBookmakers = bookmakers.filter((bookmaker) => bookmaker.name !== "BestOdds");
		const bookmakersList = [bestOdds, ...filteredBookmakers];

		return (
			<div className='root__pageHeader'>
				<div
					className={classnames("root__pageHeaderContainer", {
						root__pageHeaderContainerUserLoggedIn: isLoggedToAnyBookmaker,
					})}
				>
					<div className='root__pageHeaderSelectedOddsWrapper'>
						<div className='root__pageHeaderTitles'>
							<div className='root__pageHeaderMainTitle'>
								<Svg iconName='bookmakerLogo' size='Large' />
								<h1 data-test-selector='Text__MyBookmakersPageHeader'>
									my bookmakers
								</h1>
							</div>
							{!isLoggedToAnyBookmaker && (
								<span>Log in below to see your bookmaker accounts</span>
							)}
						</div>
						<div className='root__pageHeaderSelectedOdds'>
							<span data-test-selector='Text__MyBookmakersPagePricesNotification'>
								These prices will show
								<br /> on all racecards
							</span>
							<div className='root__pageHeaderOddsDropdownWrapper'>
								<div
									className='root__pageHeaderSelectedBookmaker'
									onClick={this.toggleBookmakersDropdown}
									data-test-selector='Button__ToggleBookmakersDropdown'
								>
									<span>
										my selected odds{" "}
										<Svg iconName='chevronDown' size='SmallPlus' />
									</span>
									<div
										className='root__pageHeaderOddsDropdownValue'
										data-test-selector='Text__SelectedBookmaker'
									>
										{
											bookmakers.find(
												(bookmaker) => bookmaker.feed === selectedBookmaker
											).displayName
										}
									</div>
								</div>
								{this.state.isBestOddsDropdownActive && (
									<ul>
										{bookmakersList.map((bookmaker) => {
											if (
												!bookmaker.availableOnPhone &&
												this.state.isMobile
											) {
												return null;
											}

											return (
												<li
													key={bookmaker.displayName}
													onClick={() => {
														onSelect(bookmaker.feed);
														this.toggleBookmakersDropdown();
													}}
													data-test-selector={`Text__${bookmaker.name}__Bookmaker`}
												>
													{bookmaker.displayName}
												</li>
											);
										})}
									</ul>
								)}
							</div>
						</div>
					</div>
					{isLoggedToAnyBookmaker && (
						<div className='root__pageHeaderBookmakersBalance'>
							<ul>
								<li>
									<p data-test-selector='Text__TotalBalance'>
										Total balance
										<span>{totalBalance || "0.00"}</span>
									</p>
								</li>
								<li>
									<p data-test-selector='Text__TotaFreeBets'>
										Total free bets
										<span>
											<Svg iconName='info-aqua' size='regular' />
											{totalFreeBets || "0.00"}
										</span>
									</p>
								</li>
							</ul>
							<ul>
								{loggedInBookmakersList.map((bookmaker) => {
									const balancePercentage =
										(bookmaker.userInfo.balance /
											Number(
												(
													rawBalanceData.totalBalance.EUR +
													rawBalanceData.totalBalance.USD +
													rawBalanceData.totalBalance.GBP
												).toFixed(2)
											)) *
										100;

									return (
										<li key={bookmaker.displayName}>
											<span
												data-test-selector={`Text__${bookmaker.name}__LoggedInBookmaker`}
											>
												{bookmaker.displayName}
											</span>
											<div className='root__pageHeaderBookmakerBalance'>
												<span
													data-test-selector={`Text__${bookmaker.name}__LoggedInBookmakerBalance`}
												>
													{bookmaker.userInfo.currencySign}
													{bookmaker.userInfo.balance.toFixed(2)}
												</span>
												<div className='root__pageHeaderBookmakerBalancePercentage'>
													<hr
														className={classnames(
															{
																root__pageHeaderBet365BalancePercentage:
																	bookmaker.name === "bet365",
															},
															{
																root__pageHeaderLadbrokesBalancePercentage:
																	bookmaker.name === "ladbrokes",
															},
															{
																root__pageHeaderCoralBalancePercentage:
																	bookmaker.name === "coral",
															},
															{
																root__pageHeaderBetfairBalancePercentage:
																	bookmaker.name === "betfair",
															},
															{
																root__pageHeaderWhBalancePercentage:
																	bookmaker.name ===
																	"williamHill",
															},
															{
																root__pageHeaderPpBalancePercentage:
																	bookmaker.name === "paddyPower",
															},
															{
																root__pageHeaderSkybetBalancePercentage:
																	bookmaker.name === "skybet",
															}
														)}
														style={{
															width:
																bookmaker.userInfo.balance === 0
																	? "1px"
																	: `${balancePercentage}%`,
														}}
													/>
												</div>
											</div>
										</li>
									);
								})}
							</ul>
						</div>
					)}
				</div>
			</div>
		);
	}
}

BookmakersListHeader.propTypes = {
	bookmakers: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string.isRequired,
			registrationOffer: PropTypes.string,
			isLoggedIn: PropTypes.bool,
			onLogout: PropTypes.func,
			userInfo: PropTypes.shape({
				name: PropTypes.string,
				balance: PropTypes.number,
				showBalance: PropTypes.bool,
				currencySign: PropTypes.string.isRequired,
			}).isRequired,
		})
	).isRequired,
	// eslint-disable-next-line react/require-default-props
	selectedBookmaker: PropTypes.string,
	onSelect: PropTypes.func.isRequired,
	// eslint-disable-next-line react/forbid-prop-types
	loggedInBookmakersList: PropTypes.array,
};

export default BookmakersListHeader;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/components/BookmakersListHeader.jsx